import React from 'react';
import { Transition } from '@headlessui/react';

import { PrimaryButton } from 'Components/Button';
import { RenderWYSIWYG } from 'Components/Form';

import { Event } from 'Services';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTimes} from "@fortawesome/free-solid-svg-icons";

export default class Info extends React.Component {

    /**
     * @method componentDidMount
     */
    componentDidMount = () => {
        Event.on('content-open', this.handleOtherOpen);
    };

    /**
     * @method componentWillUnmount
     */
    componentWillUnmount = () => {
        Event.removeListener('content-open', this.handleOtherOpen);
    };

    /**
     * @method handleOtherOpen
     */
    handleOtherOpen = () => this.setState({
        show: false,
    });

    /**
     * @method render
     * @return {JSX.Element}
     */
    render () {
        const { className, style, size, show, scale,children } = this.props;

        return (
            <>
                {children}
                <div className={`absolute ${className} ${show ? 'z-50' : ''}`} style={style}>
                    {this.renderInfoPopup()}
                </div>
            </>
        );
    }

    /**
     * @method renderPopup
     * @return {JSX.Element}
     */
    renderInfoPopup = () => {
        const { title, body, position, link, link_text, show } = this.props;

        let positionClassName = '';

        switch (position) {
            case 'left':
                positionClassName = 'info-box-right top-0 right-20';
                break;
            case 'left-bottom':
                positionClassName = 'info-box-right bottom-0 right-20';
                break;
            case 'right-bottom':
                positionClassName = 'info-box-left bottom-0 left-20';
                break;
            case 'right':
            default:
                positionClassName = 'info-box-left top-0 left-20';
                break;
        }

        return (
            <Transition
                show={show}
                enter="ease-in-out duration-500"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in-out duration-500"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
                className={`z-50 absolute bg-white shadow-lg p-4 md:p-8 rounded-lg w-120 info-box ${positionClassName} overflow-y-scroll`}
                style={{
                    maxHeight: '35vh'
                }}
            >
                <div className="absolute right-2 top-2">
                    <button onClick={this.handleToggleShow} className="rounded-full border-black border-2 w-6 h-6 flex items-center justify-center transition duration-200 transform hover:scale-110">
                        <FontAwesomeIcon
                            icon={faTimes}
                        />
                    </button>
                </div>

                <p className="text-app-teal text-xl">{title}</p>

                <div className="text-md">
                    <RenderWYSIWYG
                        content={body}
                    />
                </div>

                {link && (
                    <a
                        href={link}
                        target="_blank"
                    >
                        <PrimaryButton
                            text={link_text}
                            className="mt-2 md:mt-8"
                        />
                    </a>
                )}
            </Transition>
        );
    };
}
